import {
  canAccessSackBoleta,
  canAccessSackFactura,
  canManageUsers,
  canSynchronize,
  isEmpresaDinar,
  isEmpresaSack,
  isVendedor,
} from "./permissions";

export const buildResponsiveMenu = ({ isDinar, isSack, offlineMode }) => {
  const canUseDinar = isDinar && isEmpresaDinar();
  const canUseSack = isSack && isEmpresaSack();
  if (offlineMode) {
    const offlineItems = [];

    if (canUseDinar) {
      offlineItems.push({
        label: "Ingresar Nota de Venta",
        icon: "pi pi-file",
        to: "/nota-venta",
      });
    }

    if (canUseSack) {
      if (canAccessSackBoleta()) {
        offlineItems.push({
          label: "Cotización Boleta",
          icon: "pi pi-file",
          to: "/boleta",
        });
      }
      if (canAccessSackFactura()) {
        offlineItems.push({
          label: "Cotización Factura",
          icon: "pi pi-file-o",
          to: "/factura",
        });
      }
    }

    offlineItems.push({
      label: "Modo Offline",
      icon: "pi pi-database",
      to: "/offline",
    });

    return [
      {
        label: "Menú Principal",
        icon: "pi pi-fw pi-list",
        items: offlineItems,
      },
    ];
  }

  const items = [];

  if (canUseDinar) {
    items.push({ label: "Tablero", icon: "pi pi-chart-line", to: "/tablero" });
    items.push({
      label: "Ingresar Nota de Venta",
      icon: "pi pi-file",
      to: "/nota-venta",
    });
    items.push({
      label: "Reportes",
      icon: "pi pi-chart-bar",
      items: [
        { label: "Reportes", icon: "pi pi-book", to: "/reporte-cotizacion" },
        { label: "Tiempo respuesta", icon: "pi pi-clock", to: "/reporte-tiempo-respuesta" },
        ...(!isVendedor()
          ? [{ label: "Detalles no confirmados", icon: "pi pi-exclamation-circle", to: "/reporte-no-confirmados" }]
          : []),
      ],
    });
  }

  if (canUseSack) {
    if (canAccessSackBoleta()) {
      items.push({ label: "Cotización Boleta", icon: "pi pi-file", to: "/boleta" });
    }
    if (canAccessSackFactura()) {
      items.push({ label: "Cotización Factura", icon: "pi pi-file-o", to: "/factura" });
    }
    items.push({ label: "Cotizaciones", icon: "pi pi-folder", to: "/reporte-cotizacion" });
    items.push({
      label: "Reportes",
      icon: "pi pi-chart-bar",
      items: [
        { label: "Tablero", icon: "pi pi-book", to: "/tablero" },
        { label: "Lista de Cotizaciones", icon: "pi pi-book", to: "/reporte-cotizacion" },
      ],
    });
  }

  const mantenedores = [];

  if (canUseSack) {
    if (canManageUsers()) {
      mantenedores.push({ label: "Usuarios", icon: "pi pi-users", to: "/usuarios" });
    }
  } else if (canUseDinar) {
    if (canManageUsers()) {
      mantenedores.push({ label: "Usuarios", icon: "pi pi-users", to: "/usuarios" });
    }
    if (canSynchronize()) {
      mantenedores.push({ label: "Sincronizar", icon: "pi pi-refresh", to: "/sincronizar" });
    }
  }

  if (mantenedores.length) {
    items.push({ label: "Mantenedores", icon: "pi pi-cog", items: mantenedores });
  }

  items.push({ label: "Modo Offline", icon: "pi pi-database", to: "/offline" });
  if (canUseDinar || canUseSack) items.push({ label: "Perfil", icon: "pi pi-user", to: "/perfil" });

  return [{ label: "Menú Principal", icon: "pi pi-fw pi-list", items }];
};
